import { ToolGroup, ToolGroupId, ToolPhaseType, ToolsKeys } from "@/app/types/home/HomeTools";

export const TOOL_GROUP_CSS_CLASS: Record<ToolGroupId, string> = {
  [ToolGroupId.AVAILABLE]: "groupLabelAvailable",
  [ToolGroupId.UPCOMING]: "groupLabelUpcoming",
};

export function buildToolGroups(phases: ToolPhaseType[], keys: ToolsKeys): ToolGroup[] {
  const tools = phases.flatMap((phase) => phase.tools);

  return [
    {
      id: ToolGroupId.AVAILABLE,
      tools: tools.filter((tool) => tool.available),
    },
    {
      id: ToolGroupId.UPCOMING,
      label: keys.upcoming,
      tools: tools.filter((tool) => !tool.available),
    },
  ].filter((group) => group.tools.length > 0);
}
